'use client'

import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Language } from "@mui/icons-material";
import "flag-icon-css/css/flag-icons.min.css";
import cookies from "js-cookie";
import "./localization-header.css";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  ClickAwayListener,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Popper,
  Typography,
  useMediaQuery,
} from "@mui/material";

// project imports
import Transitions from "@/app/ui-component/extended/Transitions";

// assets
import TranslateTwoToneIcon from "@mui/icons-material/TranslateTwoTone";
import useConfig from "@/app/hooks/useConfig";
import { getUniversityName } from "@/app/global-functions/getUniversityName";
import LanguageUtils from "@/app/global-functions/LanguageUtils";
import { useSelector } from "@/app/store";
import { useRouter } from 'next/navigation';  // Import from the next/navigation
import { handleRedirection } from "@/app/global-functions/handleRedirection";
import { deconnection } from "@/app/global-functions/UserEnLigneLogOut";
import { useLocalization } from "../../LocalizationProvider";

// ==============================|| LOCALIZATION ||============================== //

 // const LocalizationSection = () => {
  const LocalizationSection = forwardRef((props, ref) => {

  const { borderRadius, locale, onChangeLocale } = useConfig();

  const theme = useTheme();
  const matchesXs = useMediaQuery(theme.breakpoints.down("md"));

  const [open, setOpen] = useState(false);
//   const [language, setLanguage] = useState("");
    const [language, setLanguage] = useState(locale);

  const [showLnguage, setShowLnguage] = useState(false);

  const currentLanguageCode = cookies.get("i18next") || "en";
  // const currentLanguage = languages.find((l) => l.code === currentLanguageCode);

  const currentLanguage = LanguageUtils.getByCode(currentLanguageCode);

  const componentRefLanguages = useRef();
  const [abreviaturaUniversidade, setabreviaturaUniversidade] = useState("");
  const [universidae, setUniversidae] = useState("");

  const [changedLamguaUser, setChangedLamguaUser] = useState(0);

  const [userPrefereedLanguage, setuserPrefereedLanguage] = useState("");

  const [loginInOkay, setloginInOkay] = useState(0);

  const { paramMemoire } = useSelector((state) => state.diversParametersRedux);
  const [isUserLoggedOut, setIsUserLoggedOut] = useState(false);

  const router = useRouter();
  const [userID, setUserID] = useState(0);

  const textColor = theme.palette.mode === 'dark' ? 'white' : theme.palette.text.primary;
  
  const localizationRef = useLocalization(); // Access the shared ref

  const [languageChangedFromImperative, setlanguageChangedFromImperative] = useState(0);


  useImperativeHandle(ref, () => ({
    changeLanguage: (newLanguage) => {
      // Update the state with the new language
      setLanguage(newLanguage);  
      // Update the locale using the provided handler
      onChangeLocale(newLanguage);
      setuserPrefereedLanguage(newLanguage);

      setlanguageChangedFromImperative(1)

      // Mark the language as changed
     //   setChangedLamguaUser(1);
    },
  }));

  useEffect(() => {

    if(Number(languageChangedFromImperative) ===1) {
      onChangeLocale(language);
      setuserPrefereedLanguage(language);
  
  
     // console.log("Currentlanguage188888: ", language); // Debug current language
    
    }
   
  }, [language, userPrefereedLanguage, languageChangedFromImperative]);

  useEffect(() => {

   // if(loginInOkay > 0) {
    // Function that will be called when the user tries to navigate away from the page
    const handleBeforeUnload =async (event) => {
      if (!isUserLoggedOut) {
       //  console.log("User is navigating away or closing the tab without logging out.");
        event.preventDefault();
        event.returnValue = ''; // This line is required for the confirmation dialog in most browsers
      
        await deconnection(userID, 0, 0); // Call the disconnection only once

        await handleRedirection(abreviaturaUniversidade, router);

        return '';
    //  }
    };

    // Listen for the beforeunload event only if the user hasn't logged out
    if (!isUserLoggedOut) { 
      window.addEventListener('beforeunload', handleBeforeUnload);
    }

    // Cleanup event listener when the component is unmounted
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };

  }
  }, [isUserLoggedOut, loginInOkay]);

  const handleListItemClick = (event, lng) => {

    setLanguage(lng);
    onChangeLocale(lng);
    setOpen(false);

    setChangedLamguaUser(1);

  };

  const handleToggle = () => {
    // setShowLnguage(!showLnguage);
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (
      componentRefLanguages.current &&
      componentRefLanguages.current.contains(event.target)
    ) {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {

    if(Number(languageChangedFromImperative) ===0)

    {
    paramMemoire.map((item) => {
      setuserPrefereedLanguage((item.language));
       setUserID(item.id);
       setloginInOkay(item.id);
       setIsUserLoggedOut(item.isLoggedIn2)

       } )

       const fetchData = async () => {
        try {
          await fetchUniversityName();

          // Determine the initial language based on the university abbreviation
          let initialLanguage = null;
          
          if (abreviaturaUniversidade === "FUTURISSTESTSdelete" ||
              abreviaturaUniversidade === "ISPOZANGO" ||
              abreviaturaUniversidade === 'UCAN' ||
              abreviaturaUniversidade === 'ISPOZANGOSEDE' ||
              abreviaturaUniversidade === "IDERO") {
                initialLanguage = "pt";
                setLanguage("pt");
                onChangeLocale("pt");
                setChangedLamguaUser(1);
                
          } else if (abreviaturaUniversidade === "FUTURISS" ||
                     abreviaturaUniversidade === "UNIKIN" ||
                     abreviaturaUniversidade === "LECARTESIEN" ||
                     abreviaturaUniversidade === "CUM" ||
                     abreviaturaUniversidade === "PETISLUTINS" ||
                     abreviaturaUniversidade === "FUTURISSTESTS" ||
                     abreviaturaUniversidade === "ESAE"
                     ) 
                     {
            initialLanguage = "fr";
          }else 
          if (abreviaturaUniversidade === "SIERASCHOOLS" ) {
            initialLanguage = "en";
            setLanguage("en");
            onChangeLocale("en");
            setChangedLamguaUser(1);
            
      } 
          
          // Only set the language if the user has not set a preferred language

       // //    alert("userPrefereedLanguage#### " + userPrefereedLanguage)
         
          if (userPrefereedLanguage !== "null" 
          && userPrefereedLanguage !== "" 
          && userPrefereedLanguage !== undefined
          && Number(changedLamguaUser) === 0) {
            
              setLanguage(userPrefereedLanguage);
              onChangeLocale(userPrefereedLanguage);
              setChangedLamguaUser(1);
            
          }
          
        } catch (error) {
         console.log(error);

        }
      };
    

    fetchData(); // Call the async function

    }

    return () => {
    };
  }, [abreviaturaUniversidade, universidae]); // Trigger effect on abreviaturaUniversidade change


  const fetchUniversityName = async () => {

    const university = await getUniversityName();
    setabreviaturaUniversidade(university.abreviatura);
    setUniversidae(university.nomUniversite);

  };


  const prevOpen = useRef(open);
  useEffect(() => {

    if (prevOpen.current === true && open === false) {
      componentRefLanguages.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  useEffect(() => {
    document.body.dir = currentLanguage.dir || "ltr"; // || 'ltr in case of langue that have left to right direction'
    
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
    function handleClick(e) {
      if (componentRefLanguages && componentRefLanguages.current) {
        const ref = componentRefLanguages.current;
        if (!ref.contains(e.target)) {
          setShowLnguage(false); // close the popup after clicking outside
        }
      }
    }
  }, [locale, currentLanguage]);

  return (
    <>
      <Box
        sx={{
          ml: 0,
          [theme.breakpoints.down("md")]: {
            ml: 0,
          },
        }}
      >
        <Language
          variant="rounded"
          sx={{
            ...theme.typography.commonAvatar,
            ...theme.typography.mediumAvatar,
            border: "1px solid",
            borderColor:
              theme.palette.mode === "dark"
                ? theme.palette.dark.main
                : theme.palette.primary.light,
            background:
              theme.palette.mode === "dark"
                ? theme.palette.dark.main
                : theme.palette.primary.light,
            color: theme.palette.primary.dark,
            transition: "all .2s ease-in-out",
            '&[aria-controls="menu-list-grow"],&:hover': {
              borderColor: theme.palette.primary.main,
              background: theme.palette.primary.main,
              color: theme.palette.primary.light,
            },
          }}
          //   ref={anchorRef}
          ref={componentRefLanguages}
          aria-controls={open ? "menu-list-grow" : undefined}
          aria-haspopup="true"
          // onClick={() => {
          //     i18next.changeLanguage(language);
          //     handleToggle();
          //     // MenuDataDisplay();
          // }
          // }
          onClick={handleToggle}
          color="inherit"
        >
          {/* {language !== "fr" && ( */}
            <Typography
              variant="h5"
              sx={{ textTransform: "uppercase" }}
              color="inherit"
            >
              {language}
            </Typography>
          {/* )} */}
         {/*  {language === "fr" && (
            <TranslateTwoToneIcon sx={{ fontSize: "1.3rem" }} />
          )} */}

        </Language>
        
        <label style={{textTransform:"uppercase", color:textColor, fontSize:"12px", fontWeight:600}}>{language}</label>
      </Box>
      <Popper
  placement={matchesXs ? "bottom-start" : "bottom"}
  open={open}
  anchorEl={componentRefLanguages.current}
  role={undefined}
  transition
  disablePortal
  sx={{
    zIndex: 1300, // Set the z-index to ensure it's above other components
  }}
  popperOptions={{
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [matchesXs ? 0 : 0, 20],
        },
      },
    ],
  }}
>
  {({ TransitionProps }) => (
    <ClickAwayListener onClickAway={handleClose}>
      <Transitions
        position={matchesXs ? "top-left" : "top"}
        in={open}
        {...TransitionProps}
      >
        <Paper elevation={16}>
          {open && (
            <List
              component="nav"
              sx={{
                width: "100%",
                minWidth: 200,
                maxWidth: 280,
                bgcolor: theme.palette.background.paper,
                borderRadius: `${borderRadius}px`,
                [theme.breakpoints.down("md")]: {
                  maxWidth: 250,
                },
              }}
            >
              <ListItemButton
                selected={language === "pt"}
                onClick={(event) => handleListItemClick(event, "pt")}
              >
                <ListItemText
                  primary={
                    <Grid container>
                      <Typography color="textPrimary">Potuguês</Typography>
                      <Typography
                        variant="caption"
                        color="textSecondary"
                        sx={{ ml: "8px" }}
                      >
                        (Potuguês)
                      </Typography>
                    </Grid>
                  }
                />
              </ListItemButton>
              <ListItemButton
                selected={language === "fr"}
                onClick={(event) => handleListItemClick(event, "fr")}
              >
                <ListItemText
                  primary={
                    <Grid container>
                      <Typography color="textPrimary">Français</Typography>
                      <Typography
                        variant="caption"
                        color="textSecondary"
                        sx={{ ml: "8px" }}
                      >
                        (Français)
                      </Typography>
                    </Grid>
                  }
                />
              </ListItemButton>
              <ListItemButton
                selected={language === "es"}
                onClick={(event) => handleListItemClick(event, "es")}
              >
                <ListItemText
                  primary={
                    <Grid container>
                      <Typography color="textPrimary">Espanhol</Typography>
                      <Typography
                        variant="caption"
                        color="textSecondary"
                        sx={{ ml: "8px" }}
                      >
                        (Español)
                      </Typography>
                    </Grid>
                  }
                />
              </ListItemButton>
              <ListItemButton
                selected={language === "ar"}
                onClick={(event) => handleListItemClick(event, "ar")}
              >
                <ListItemText
                  primary={
                    <Grid container>
                      <Typography color="textPrimary">عرب</Typography>
                      <Typography
                        variant="caption"
                        color="textSecondary"
                        sx={{ ml: "8px" }}
                      >
                        (عرب)
                      </Typography>
                    </Grid>
                  }
                />
              </ListItemButton>
              <ListItemButton
                selected={language === "en"}
                onClick={(event) => handleListItemClick(event, "en")}
              >
                <ListItemText
                  primary={
                    <Grid container>
                      <Typography color="textPrimary">English</Typography>
                      <Typography
                        variant="caption"
                        color="textSecondary"
                        sx={{ ml: "8px" }}
                      >
                        (English)
                      </Typography>
                    </Grid>
                  }
                />
              </ListItemButton>
            </List>
          )}
        </Paper>
      </Transitions>
    </ClickAwayListener>
  )}
</Popper>
    </>
  );
});


export default LocalizationSection;
